import { Component, OnInit } from '@angular/core';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import { VentaService } from 'src/app/api/venta.service';

@Component({
  selector: 'app-pago-xml',
  templateUrl: './pago-xml.component.html',
  styleUrls: ['./pago-xml.component.css']
})
export class PagoXmlComponent implements OnInit {

  constructor(
    private _api: IntranetoldService,
    private _ventaService: VentaService
  ) {}

  // Búsqueda
  searchDocNum: string = '';
  searchDocEntry: string = '';

  // Tabla
  pagos: any[] = [];
  cargando = false;
  descargando: { [key: number]: boolean } = {};
  mensaje = '';
  mensajeError = '';

  async ngOnInit() {
    await this.cargarUltimos100();
  }

  async cargarUltimos100() {
    this.cargando = true;
    this.mensaje = '';
    this.mensajeError = '';
    try {
      const sql = `SELECT TOP 100 "DocEntry", "DocNum", "CardCode", "CardName", "DocDate", "DocTotal", "DocCurr" FROM ORCT ORDER BY "DocEntry" DESC`;
      const res: any = await this._api.GetNotFileQuery(sql);
      this.pagos = Array.isArray(res?.objeto) ? res.objeto : [];
      if (this.pagos.length === 0) {
        this.mensaje = 'No se encontraron pagos recibidos';
      }
    } catch (err) {
      
      this.mensajeError = 'Error al cargar los pagos recibidos';
      this.pagos = [];
    } finally {
      this.cargando = false;
    }
  }

  async buscar() {
    this.mensaje = '';
    this.mensajeError = '';

    const docNum = (this.searchDocNum || '').trim();
    const docEntry = (this.searchDocEntry || '').trim();

    if (!docNum && !docEntry) {
      await this.cargarUltimos100();
      return;
    }

    this.cargando = true;
    try {
      let sql = '';
      if (docEntry) {
        sql = `SELECT "DocEntry", "DocNum", "CardCode", "CardName", "DocDate", "DocTotal", "DocCurr" FROM ORCT WHERE "DocEntry" = ${parseInt(docEntry, 10)}`;
      } else if (docNum) {
        sql = `SELECT "DocEntry", "DocNum", "CardCode", "CardName", "DocDate", "DocTotal", "DocCurr" FROM ORCT WHERE "DocNum" = ${parseInt(docNum, 10)}`;
      }

      const res: any = await this._api.GetNotFileQuery(sql);
      this.pagos = Array.isArray(res?.objeto) ? res.objeto : [];
      if (this.pagos.length === 0) {
        this.mensaje = 'No se encontraron resultados para la búsqueda';
      }
    } catch (err) {
      
      this.mensajeError = 'Error al buscar el pago';
      this.pagos = [];
    } finally {
      this.cargando = false;
    }
  }

  limpiar() {
    this.searchDocNum = '';
    this.searchDocEntry = '';
    this.mensaje = '';
    this.mensajeError = '';
    this.cargarUltimos100();
  }

  async descargarXML(pago: any) {
    const docEntry = pago.DocEntry;
    if (!docEntry) return;

    this.descargando[docEntry] = true;
    this.mensajeError = '';
    try {
      const res: any = await this._ventaService.obtienePagoRecibidoXML(docEntry);
      if (res?.estado && res?.resultado) {
        const xml = res.resultado;
        const blob = new Blob([xml], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `PagoRecibido_${pago.DocNum || docEntry}.xml`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else {
        this.mensajeError = res?.mensaje || 'Error al obtener el XML del pago';
      }
    } catch (err) {
      
      this.mensajeError = 'Error al descargar el XML del pago ' + docEntry;
    } finally {
      this.descargando[docEntry] = false;
    }
  }
}
